import axios from 'axios';
import { API_BASE_URL } from '../config';
import { getAuthTokens } from '../utils/auth';
import api from './middleware';

export const apicallApi = {
  // Create a new API call
  createApiCall: async (apiCallData) => {
    try {
      // Send the data as is without transformation
      const response = await api.post(
        '/api/api-requests',
        apiCallData
      );

      return response.data;
    } catch (error) {
      console.error('Create API call error:', error);
      throw error;
    }
  },

  // Get all API calls
  getAllApiCalls: async () => {
    try {
      const response = await api.get('/api/api-requests/list');

      // Transform the response to match our frontend model
      const transformedData = response.data.map(item => ({
        id: item.id,
        name: item.name,
        method: item.http_method,
        url: item.url_template,
        body: item.body_template,
        position: item.position
      }));

      return transformedData;
    } catch (error) {
      console.error('Get API calls error:', error);
      throw error;
    }
  },

  // Get API call by ID
  getApiCallById: async (apiCallId) => {
    try {
      const response = await api.get(`/api/api-requests/${apiCallId}`);

      // Transform the response to match our frontend model
      const transformedData = {
        id: response.data.id,
        name: response.data.name,
        method: response.data.http_method,
        url: response.data.url_template,
        body: response.data.body_template,
        position: response.data.position
      };

      return transformedData;
    } catch (error) {
      console.error('Get API call error:', error);
      throw error;
    }
  },

  // Update API call
  updateApiCall: async (apiCallId, apiCallData) => {
    try {
      // Transform the data to match the backend model
      const transformedData = {
        name: apiCallData.name,
        url_template: apiCallData.url,
        http_method: apiCallData.method,
        body_template: apiCallData.body || {},
        position: apiCallData.position || 0
      };

      const response = await api.put(
        `/api/api-requests/${apiCallId}`,
        transformedData
      );

      return response.data;
    } catch (error) {
      console.error('Update API call error:', error);
      throw error;
    }
  },

  // Delete API call
  deleteApiCall: async (apiCallId) => {
    try {
      const response = await api.delete(`/api/api-requests/${apiCallId}`);
      return response.data;
    } catch (error) {
      console.error('Delete API call error:', error);
      throw error;
    }
  }
};

export default apicallApi; 